import InternshipForm from './InternshipForm';
export default InternshipForm;
